import React from 'react'
import {Link} from 'react-router-dom'

const ProfilePanel = ({setHiddenPanelClassName}) => {
  return (
    <div className="hidden-panel__profile hidden-panel__profile_visible"
         onClick={() => setHiddenPanelClassName('')}>
      <Link to="/">Личный кабинет</Link>
      <Link to="/favorite">
        <i className="fa fa-heart-o" aria-hidden="true"/>Избранное</Link>
      <Link to="/">Выйти</Link>
    </div>
  )
};

export default ProfilePanel
